import {store} from 'store';
import {pick} from "helpers";

export function updateListAndItems(list) {
  if (list.id) {
    store.dispatch({
      type: 'LIST_UPDATE',
      list,
    });
    if (list.items) {
      store.dispatch({
        type: 'LIST_ITEMS_UPDATE',
        list: {
          ...list,
          items: list.items.filter(item => item.name).map(item => ({
            ...item,
            listId: list.id,
          }))
        },
      });
    }
  } else if (list.name) {
    store.dispatch({
      type: 'LIST_UPDATE',
      list: pick(list, 'id', 'name'),
      historyPush: '/lists/'
    });
  }
}

export function updateListItem(listItem) {
  if (listItem && listItem.id) {
    store.dispatch({
      type: 'LIST_ITEM_UPDATE',
      listItem: {
        ...listItem
      },
    });
  }
}

export function deleteList(id) {
  store.dispatch({
    type: 'LIST_DELETE',
    id,
    historyPush: '/lists/'
  });
}

export function toggleListItem(id) {
  store.dispatch({
    type: 'LIST_ITEM_TOGGLE',
    id,
  });
}
